import { GridAction } from '@eforall/dashboard';

export function getActions() {

	const actions: GridAction<{ id: number, name: string, status: string, updatedUTC: number }>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View',
			isEnabled: rows => !!rows.length,
			execute: async rows => { console.log(`Action clicked!`, rows) }
		},
	];

	return actions;
}